import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultar-ripleypuntos',
  templateUrl: './consultar-ripleypuntos.component.html',
  styleUrls: ['./consultar-ripleypuntos.component.scss'],
})
export class ConsultarRipleypuntosComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
